<template>
    <portal
      to="modal"
      :disabled="!isShow"
      :style="{ position: 'absolute' }"
    >
      <ar-modal
        :is-open="isShow"
        class="ticket-tailor-modal"
        header="Connect to Ticket Tailor"
        width="590px"
        :mobile="$arMediaQuery.window.maxWidth('xs')"
        @close="handleCloseClick"
      >
        <div
          slot="body"
          :class="[
            'ticket-tailor-modal-body',
            $arMediaQuery.window.maxWidth('xs') && 'u-padding-x-3',
          ]"
        >

          <ar-field
            label="Account name(any)"
            class="u-margin-top-5"
          >
            <ar-input
              v-model="accountName"
              name="accountName"
              placeholder="Please enter a name for your account"
              id="ticket-tailor-account-name-input"
              type="text"
              data-test-id="ticket-tailor-account-name-input"
            />
          </ar-field>

          <ar-field
            label="Api Key"
            class="u-margin-top-5"
          >
            <ar-input
              v-model="apiKey"
              name="apiKey"
              placeholder="Please enter your Ticket Tailor api key"
              id="ticket-tailor-api-key-input"
              type="text"
              data-test-id="ticket-tailor-api-key-input"
            />
          </ar-field>
        </div>

        <div
          slot="footer"
          :class="[
            'ticket-tailor-modal-footer',
            $arMediaQuery.window.maxWidth('xs') && 'u-padding-x-3',
          ]">
          <ar-simple-button
            text="Confirm"
            :loading="loading"
            :disabled="confirmButtonDisabled"
            :style="{ width: '108px' }"
            @click="handleConfirmClick"
            id="ticket-tailor-confirm-button"
            data-test-id="ticket-tailor-confirm-button"
          />
        </div>
      </ar-modal>
    </portal>
  </template>

  <script>
  import { mapActions } from 'vuex';

  export default {
    name: 'AskInputModal',
    components: {},
    props: {
      isShow: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        apiKey: "",
        accountName: ""
      };
    },

    computed: {
      confirmButtonDisabled() {
        return !this.apiKey || !this.accountName;
      }
    },

    watch: {
      isShow(val) {
        if (val) {
          this.apiKey = null;
          this.accountName = null;
        }
      },
    },

    methods: {
      ...mapActions([
        'ticketTailorIntegration/FETCH_INTEGRATION',
        'ticketTailorIntegration/CREATE_TICKET_TAILOR_INTEGRATION',
      ]),
      async fetchIntegration() {
        const success = await this['ticket-tailorIntegration/FETCH_INTEGRATION']()
        return success;
      },
      async handleConfirmClick() {
        this.errorMessage = null;
        this.httpStatus = null;
        const apiKey = this.apiKey;
        const accountName = this.accountName;
        const response = await this['ticketTailorIntegration/CREATE_TICKET_TAILOR_INTEGRATION']({
          apiKey, accountName
        });
        if (response) {
          if (this.$route.path != '/settings/integrations/ticket-tailor') {
            await this.$router.push({ path: '/settings/integrations/ticket-tailor' });;
          }
          else {
            this.fetchIntegration();
          }
          this.$emit('cancel');
        }
        else {
          this.errorMessage = response.message;
          this.httpStatus = response.httpStatusCode;
        }
      },
      handleCloseClick() {
        this.$emit('cancel');
      },
      toggleApplyPrefix() {
        this.applyPrefix = !this.applyPrefix;
      }
    },
  };
  </script>

  <style lang="scss" scoped>
  .ticket-tailor-modal {
    .ticket-tailor-modal-body {
      padding: 20px 30px 30px;

      &:nth-child(2) {
        border-top: 1px solid $blueGrey500;
      }
    }
    .ticket-tailor-modal-footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 25px 30px;
      height: 100px;
    }
  }
  </style>
